

import React from 'react';
import { 
  Paper, 
  Typography,
  useTheme,
  Box
} from '@mui/material';
import { 
  RadialBarChart,
  RadialBar,
  PolarAngleAxis,
  ResponsiveContainer
} from 'recharts';
import { useAuth } from '../../../AuthContext';
import { Speed } from '@mui/icons-material';
import SectionHeader from './SectionHeader';

const RPMMeter = ({ sx }) => {
  const { data } = useAuth();
  const theme = useTheme();
  
  const rpmData = [{ value: data?.rpm || 0 }];
  
  const getColor = (rpm) => {
    if (!rpm) return theme.palette.grey[500];
    return rpm < 1000 ? theme.palette.error.main : theme.palette.success.main;
  };

  return (
    <Paper sx={{ 
        borderRadius: theme.shape.borderRadius * 2,
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx
      }}>
         <SectionHeader icon={<Speed fontSize="small" />} title="Motor RPM" />
      <Typography
        variant="subtitle1"
        fontWeight="600"
        mb={2}
        sx={{ textAlign: 'center' }}
      >
        Motor RPM
      </Typography>

      <Box sx={{ flex: 1, minHeight: 250, }}>
        <ResponsiveContainer width="100%" height="100%" >
          <RadialBarChart
            innerRadius="70%"
            outerRadius="90%"
            data={rpmData}
            startAngle={180}
            endAngle={0}
          >
            <PolarAngleAxis
              type="number"
              domain={[0, 3000]}
              angleAxisId={0}
              tick={{ fill: theme.palette.text.primary }}
              tickFormatter={(value) => `${value}`}
              tickLine={false}
              radius={120}
            />
            <RadialBar
              background
              dataKey="value"
              cornerRadius={10}
              fill={getColor(data?.rpm)}
            />
            <text
              x="50%"
              y="50%"
              textAnchor="middle"
              dominantBaseline="middle"
              fill={getColor(data?.rpm)}
              style={{ 
                fontSize: '1.5rem',
                fontWeight: 600 
              }}
            >
              {data?.rpm || '--'} RPM
            </text>
          </RadialBarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default React.memo(RPMMeter);